import {
    Injectable, Output, EventEmitter
} from '@angular/core'
import { BehaviorSubject } from 'rxjs';
  @Injectable()
  export class PrintService {
    PrintLayoutInfo = new EventEmitter(null);
    PrintURLEmitter = new EventEmitter(null);
    public TabOpenEvent = this.PrintLayoutInfo.asObservable();
    constructor() {
    }
    OpenPrintLayout(data: any) {
      this.PrintLayoutInfo.emit(data);
    }
    Print(){      
      window.print();
    }
    PrintURL(url: string)
    {
      this.PrintURLEmitter.emit(url);
    }
  }